import { TransitionPageComponent } from './pages/transition-page/transition-page.component';
import { InnovationProductivityComponent } from './pages/home/components/innovation-productivity/innovation-productivity.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PAGES } from './constants/route.constants';
import { HomeComponent } from './pages/home/home.component';
import { LandingComponent } from './pages/landing/landing.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { MsalGuard } from '@azure/msal-angular';
import { LogoutComponent } from './pages/logout/logout.component';
import { SessionExpiredComponent } from './pages/session-expired/session-expired.component';
import { EngagementDetailsComponent } from './pages/engagement-details/engagement-details.component';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';
import { AssetLibraryComponent } from './pages/asset-library/asset-library.component';
import { ContractualDocsComponent } from './pages/contractual-docs/contractual-docs.component';
import { GovernanceMeetingComponent } from './pages/governance-meetings/governance-meetings.component';
import { InnovationProductivityPageComponent } from './pages/innovation-productivity-page/innovation-productivity-page.component';
import { PowerBiDashboardComponent } from './pages/dashboard/powerbi.dashboard.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: PAGES.LANDING,
    pathMatch: 'full',
  },
  {
    path: PAGES.LANDING,
    canActivate: [MsalGuard],
    component: LandingComponent,
  },
  {
    path: PAGES.HOME,
    canActivate: [MsalGuard],
    component: HomeComponent,
  },
  {
    path: PAGES.ENGAGEMENTDETAILS,
    canActivate: [MsalGuard],
    component: EngagementDetailsComponent,
  },
  {
    path: PAGES.SESSION_EXPIRED,
    canActivate: [MsalGuard],
    component: SessionExpiredComponent,
  },

  {
    path: PAGES.LOGOUT,
    component: LogoutComponent,
  },
  {
    path: PAGES.PAGE_NOT_FOUND,
    component: PageNotFoundComponent,
  },
  {
    path: PAGES.NO_ACCESS,
    component: AccessDeniedComponent,
  },
  {
    path: PAGES.ASSET_LIBRARY,
    canActivate: [MsalGuard],
    component: AssetLibraryComponent,
  },
  {
    path: PAGES.CONTRACTUAL_DOCS,
    canActivate: [MsalGuard],
    component: ContractualDocsComponent,
  },
  {
    path: PAGES.GOVERNANCE_MEETINGS,
    canActivate: [MsalGuard],
    component: GovernanceMeetingComponent,
  },
  {
    path: PAGES.INNOVATION_PRODUCTIVITY,
    canActivate: [MsalGuard],
    component: InnovationProductivityPageComponent,
  },
  {
    path: PAGES.TRANSITION_PAGE,
    canActivate: [MsalGuard],
    component: TransitionPageComponent,
  },
  {
    path : PAGES.POWER_BI_DASHBOARD,
    canActivate: [MsalGuard],
    component: PowerBiDashboardComponent
  },{
    path: '**',
    redirectTo: PAGES.PAGE_NOT_FOUND,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
